import { useTranslate } from "@similarweb/i18n-provider";

import { ONBOARDING_AGENT_MESSAGE_SUGGESTED_ACTIONS } from "../texts";

import { SuggestedActionsItem, SuggestedActionsLabel, SuggestedActionsList, SuggestedActionsSection } from "./styles";

export type OnboardingAgentAssistantSuggestedActionsProps = {
    readonly messageIndex: number;
    readonly actions: readonly string[];
};

export const OnboardingAgentAssistantSuggestedActions = ({
    messageIndex,
    actions,
}: OnboardingAgentAssistantSuggestedActionsProps) => {
    const { translate } = useTranslate();

    if (actions.length === 0) {
        return null;
    }

    return (
        <SuggestedActionsSection data-automation={`onboarding-agent-message-${messageIndex}-suggested-actions`}>
            <SuggestedActionsLabel data-automation={`onboarding-agent-message-${messageIndex}-suggested-actions-label`}>
                {translate(ONBOARDING_AGENT_MESSAGE_SUGGESTED_ACTIONS)}
            </SuggestedActionsLabel>
            <SuggestedActionsList>
                {actions.map((action, actionIndex) => (
                    <SuggestedActionsItem
                        key={`${action}-${actionIndex}`}
                        data-automation={`onboarding-agent-message-${messageIndex}-suggested-action-${actionIndex}`}
                    >
                        {action}
                    </SuggestedActionsItem>
                ))}
            </SuggestedActionsList>
        </SuggestedActionsSection>
    );
};
